<template>
  <div id="postnatal-app" class="container-fluid">
    <!-- Header with Mother & Baby Info -->
    <pnc_full_head />

    <!-- Content Section: Mother & Child Profiles -->
    <div class="main-content row">
      <!-- Mother's Profile -->
      <div class="col-8 mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header bg-primary text-white">
              <h3 class="mb-0">
                <i class="fas fa-female"></i> Mother's Profile
              </h3>
            </div>
            <div style="margin-top: 0; padding-top: 0" class="card-body">
              <!-- user -->
              <!-- Additional Details -->
              <div class="row">
                <div class="col-6">
                  <div class="additional-details">
                    <div class="detail-item">
                      <h5>
                        <i class="fas fa-calendar-alt"></i>Basic Information
                      </h5>
                      <p>
                        <strong>Full Name:</strong>
                        {{ motherProfile.deliveryInfo.date }}
                      </p>
                      <p>
                        <strong>Age:</strong>
                        {{ motherProfile.deliveryInfo.gestationalAge }} weeks
                      </p>
                      <p>
                        <strong>Patient ID:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>Blood Group:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>Parity:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>Delivery Type:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                    </div>
                  </div>
                </div>
              <!-- </div> -->

              <!-- contacts -->
              <!-- Additional Details -->
              <!-- <div class="row"> -->
                <div class="col-6">
                  <div class="additional-details">
                    <div class="detail-item">
                      <h5>
                        <i class="fas fa-calendar-alt"></i> Contact & Medical
                        Details
                      </h5>
                      <p>
                        <strong>Phone Number:</strong>
                        {{ motherProfile.deliveryInfo.date }}
                      </p>
                      <p>
                        <strong>Address:</strong>
                        {{ motherProfile.deliveryInfo.gestationalAge }} weeks
                      </p>
                      <p>
                        <strong>Next of Kin:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>

                      <p>
                        <strong>Medical Conditions:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>

                      <p>
                        <strong>Allergies:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->

              <!-- Additional Details -->
              <div class="row">
                <div class="col-12">
                  <div class="additional-details">
                    <div class="detail-item">
                      <h5>
                        <i class="fas fa-calendar-alt"></i> Delivery Information
                      </h5>
                      <p>
                        <strong>Delivery Date:</strong>
                        {{ motherProfile.deliveryInfo.date }}
                      </p>
                      <p>
                        <strong>Gestational Age:</strong>
                        {{ motherProfile.deliveryInfo.gestationalAge }} weeks
                      </p>
                      <p>
                        <strong>Hospital/Clinic:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Children's Profiles -->
      <div class="col-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header bg-success text-white">
              <h3 class="mb-0">
                <i class="fas fa-baby"></i> Child/Children's Profiles
              </h3>
            </div>
            <div style="margin-top: 0; padding-top: 0" class="card-body">
              <!-- Additional Details -->
              <div class="row">
                <div class="col-12">
                  <div class="additional-details">
                    <div class="detail-item">
                      <div class="child-basic-info">
                        <div class="child-avatar">
                          <i class="fas fa-baby fa-3x"></i>
                        </div>
                        <div class="child-details">
                          <h4>{{ currentChild.name }}</h4>
                          <div class="child-meta">
                            <span class="badge bg-info">{{
                              currentChild.gender
                            }}</span>
                            <span class="badge bg-primary"
                              >ID: {{ currentChild.id }}</span
                            >
                            <span class="badge bg-warning"
                              >Birth Weight:
                              {{ currentChild.birthWeight }} kg</span
                            >
                          </div>
                        </div>
                      </div>
                      <h5>
                        <i class="fas fa-calendar-alt"></i>Basic Information
                      </h5>
                      <p>
                        <strong>Date of birth:</strong>
                        {{ motherProfile.deliveryInfo.date }}
                      </p>
                      <p>
                        <strong>Birth Weight:</strong>
                        {{ motherProfile.deliveryInfo.gestationalAge }} weeks
                      </p>
                      <p>
                        <strong>Birth Length:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>Head Circumference:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>APGAR Score:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                      <p>
                        <strong>Delivery Type:</strong>
                        {{ motherProfile.deliveryInfo.facility }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pnc_full_head from "./mch/pnc/pnc_full_head.vue";

export default {
  name: "PNCClientProfiles",
  components: { pnc_full_head },
  data() {
    return {
      motherProfile: {
        id: "PN-2023-04567",
        name: "Sarah Johnson",
        age: 32,
        parity: "G3P2",
        deliveryType: "Vaginal",
        bloodGroup: "A+",
        contact: {
          phone: "+254 712 345 678",
          address: "123 Main Street, Nairobi",
          nextOfKin: "John Johnson (Husband)",
        },
        medicalConditions: ["Gestational Diabetes", "Hypertension"],
        allergies: ["Penicillin", "Sulfa Drugs"],
        deliveryInfo: {
          date: "2023-12-01",
          gestationalAge: 38,
          facility: "Kenyatta National Hospital",
        },
        medicalHistory:
          "Previous C-section in 2020. No other significant medical history.",
      },
      children: [
        {
          id: "BABY-2023-04567A",
          name: "Baby Johnson",
          gender: "Female",
          age: "7 days",
          birthWeight: "3.2",
          currentWeight: "3.1",
          birthInfo: {
            date: "2023-12-01",
            time: "10:30 AM",
            weight: "3.2 kg",
            length: "50 cm",
            headCircumference: "34 cm",
            apgarScore: "9/10",
          },
          currentStatus: {
            weight: "3.1 kg",
            length: "50.5 cm",
            feedingMethod: "Exclusive Breastfeeding",
            immunizationsUpToDate: true,
            lastVisit: "2023-12-08",
            nextAppointment: "2023-12-15",
          },
          medicalNotes:
            "Healthy newborn, breastfeeding well. Normal neonatal exam. Weight loss within acceptable range.",
          immunizationsUpToDate: true,
          healthStatus: "Good",
        },
      ],
      selectedChildId: null,
    };
  },
  computed: {
    currentChild() {
      return this.children[0];
    },
    selectedChild() {
      return this.children.find((child) => child.id === this.selectedChildId);
    },
  },
  methods: {
    selectChild(child) {
      this.selectedChildId = child.id;
    },
    addNewChild() {
      // Logic to add a new child
      alert("Add new child functionality will be implemented here");
    },
  },
};
</script>

<style scoped>
#postnatal-app {
  padding: 20px;
  background-color: #f8f9fa;
}

.main-content {
  margin-top: 20px;
}

.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.card-header {
  border-radius: 10px 10px 0 0 !important;
  padding: 15px 20px;
}

.section-title {
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.section-subtitle {
  color: #495057;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item label {
  font-weight: 600;
  color: #6c757d;
  min-width: 150px;
}

.info-value {
  font-weight: 500;
  color: #2c3e50;
  text-align: right;
}

.conditions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.condition-badge,
.allergy-badge {
  padding: 3px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
}

.condition-badge {
  background-color: #e3f2fd;
  color: #1565c0;
}

.allergy-badge {
  background-color: #ffebee;
  color: #c62828;
}

.additional-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.detail-item {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #4f6d9c;
}

.detail-item h5 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 16px;
}

.detail-item p {
  margin-bottom: 8px;
  color: #495057;
}

/* Child Profile Styles */
.child-profile-single {
  padding: 20px;
}

.child-basic-info {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.child-avatar {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.child-details h4 {
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 10px;
}

.child-meta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.medical-notes {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #28a745;
  font-size: 14px;
  color: #495057;
}

/* Multiple Children Styles */
.children-list {
  padding: 20px;
}

.child-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
}

.child-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #4f6d9c;
}

.child-card.selected {
  border-color: #4f6d9c;
  background-color: #f8f9fe;
}

.child-card-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.child-avatar-sm {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.child-name h5 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #2c3e50;
}

.child-name small {
  color: #6c757d;
}

.child-card-body {
  padding-top: 10px;
  border-top: 1px solid #e9ecef;
}

.child-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}

.stat i {
  font-size: 16px;
  margin-bottom: 5px;
  color: #4f6d9c;
}

.child-id {
  font-size: 11px;
  color: #6c757d;
  text-align: center;
}

.add-child {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-style: dashed;
  min-height: 150px;
}

.add-child-content {
  text-align: center;
  color: #6c757d;
}

.add-child-content i {
  margin-bottom: 10px;
  color: #28a745;
}

.selected-child-details {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.detail-view h4 {
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-item label {
    margin-bottom: 5px;
  }

  .info-value {
    text-align: left;
  }

  .child-basic-info {
    flex-direction: column;
    text-align: center;
  }

  .child-meta {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .additional-details {
    grid-template-columns: 1fr;
  }
}
</style>
